import {WorkorderFeedback} from "./WorkorderFeedback";
import {TaskAttachment} from "./TaskAttachment";

export class Workorder {
  constructor(
    public readonly id: string,
    public readonly task_id: string|null,
    public readonly description: string,
    public readonly teamId?: string,
    public readonly startAt?: Date,
    public readonly archivedAt?: Date,
    public readonly quantityAmount?: number,
    public readonly quantityType?: string,
    public readonly quantityTypeName?: string,
    public readonly workorderRemark?: string,
    public readonly projectRemark?: string,
    public readonly projectNumber?: string,
    public readonly projectDescription?: string,
    public readonly projectNote?: string,
    public readonly projectLocation?: string,
    public readonly projectDeliveryName?: string,
    public readonly projectDeliveryAddress?: string,
    public readonly projectDeliveryCity?: string,
    public readonly projectDeliveryZipCode?: string,
    public readonly projectDeliveryPhone?: string,
    public readonly projectDeliveryEmail?: string,
    public readonly projectDeliveryRemark?: string,
    public readonly workorderId?: string,
    public readonly isFinished?: boolean,
    public readonly archived_at?: Date,
    public readonly workorderFeedbackType?: string,
    public readonly feedback?: WorkorderFeedback[],
    public readonly attachments?: TaskAttachment[],
  ) {
  }

  static fromJson(json: any): Workorder {
    return new Workorder(
      json['id'],
      json['task_id'],
      json['description'],
      json['team_id'],
      json['start_at'] ? new Date(json['start_at']) : undefined,
      json['workorder']?.['archived_at'] ? new Date(json['workorder']?.['archived_at']) : undefined,
      json['quantity_amount'],
      json['quantity_type'],
      json['quantity_type_name'],
      json['workorder_remark'],
      json['project_remark'],
      json['project']?.['project_number'],
      json['project']?.['description'],
      json['project']?.['note'],
      json['project']?.['location'],
      json['project']?.['delivery_name'],
      json['project']?.['delivery_address'],
      json['project']?.['delivery_city'],
      json['project']?.['delivery_zipcode'],
      json['project']?.['delivery_phone'],
      json['project']?.['delivery_email'],
      json['project']?.['delivery_remark'],
      json['workorder']?.['id'],
      json['workorder']?.['is_finished'],
      json['archived_at'] ? new Date((json['archived_at'])) : undefined,
      json['workorder']?.['workorder_feedback_type'],
      json['workorder']?.['feedback'] ? json['workorder']?.['feedback'].map((f: any) => WorkorderFeedback.fromJson(f)) : [],
      json['workorder']?.['task_attachments'] ? json['workorder']?.['task_attachments']?.map((a: any) => TaskAttachment.fromJson(a)) : [],
    );

  }
}